import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {currentScreen} from '/redux/selector/navigation.selector';
import {isPopoverOpen} from '/redux/selector/popover.selector';

import BottomTabNavigation from './BottomTabNavigation';

export default connect(
  createStructuredSelector({
    currentScreen: currentScreen,
    isPopoverOpen,
  }),
)(BottomTabNavigation);
